import {
  ChoicesArticleCombination,
  ChoicesThemeProfileCodeFilter,
} from "@generated"
import { getGraphQLClient } from "@lib/graphql-client"
import { useInfiniteQuery } from "@tanstack/react-query"
import React from "react"
import LoadMore from "../../detail/LoadMore"
import { Grid } from "./Grid"

interface Props {
  firstTitle: any | null
  firstText: any | null
  secondTitle: any | null
  secondText: any | null
  themeProfile: ChoicesThemeProfileCodeFilter
}

const LIMIT = 20
const { sdk } = getGraphQLClient()

const ProductGrid: React.FC<Props> = ({
  firstTitle,
  firstText,
  secondTitle,
  secondText,
  themeProfile,
}) => {
  const {
    data: queryData,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    isFetching,
  } = useInfiniteQuery(
    // TODO: double check key on overview page with same filters
    ["newCollection"],
    ({ pageParam }) =>
      sdk.ThemeProfileCollection({
        themeProfile,
        pagination: {
          limit: LIMIT,
          skip: pageParam || undefined,
        },
      }),
    {
      getNextPageParam: (lastPage) => {
        const { items } = lastPage.choicesArticleCombinations
        if (items.length < LIMIT) {
          return undefined
        }
        return items[items.length - 1].id
      },
    }
  )
  // Flatten the array and filter nulls
  const pages = queryData?.pages ?? []
  const items: ChoicesArticleCombination[] = []

  for (const page of pages) {
    for (const edge of page?.choicesArticleCombinations.items) {
      items.push(edge as ChoicesArticleCombination)
    }
  }

  return (
    <>
      <Grid
        items={items}
        loading={isFetching}
        fetchingMore={isFetchingNextPage}
        firstTitle={firstTitle}
        firstText={firstText}
        secondTitle={secondTitle}
        secondText={secondText}
      />
      <LoadMore
        loading={isFetchingNextPage}
        disabled={!hasNextPage}
        onClick={() => fetchNextPage()}
      />
    </>
  )
}

export default ProductGrid
